import ImgFaseGrey from '../image/traffic-grey.png';
import ImgFaseGreen from '../image/traffic-green.png';
import ImgFaseYellow from '../image/traffic-yellow.png';
import ImgFaseRed from '../image/traffic-red.png';
import GifTrafficYellowBlink from '../image/traffic-yellow-blink.gif';

import ImgPedestrianGrey from '../image/pedestrian-grey.png';
import ImgPedestrianGreen from '../image/pedestrian-green.png';
import ImgPedestrianYellow from '../image/pedestrian-yellow.png';
import ImgPedestrianRed from '../image/pedestrian-red.png';
import GifPedestrianRedBlink from '../image/pedestrian-red-blink.gif';

import { corPiscanteIntervaloAtiva } from './mapaFaseUtils';

const COR_FASE_MAP = {
  Vermelho: '#e53935',
  Amarelo: '#fdd835',
  Verde: '#43a047',
  Apagado: '#9e9e9e',
};

const COR_BORDA_MAP = {
  Vermelho: '#8e0000',
  Amarelo: '#c6a700',
  Verde: '#1b5e20',
  Apagado: '#616161',
};

const ICONES_FASE = {
  Vermelho: [ImgFaseRed, ImgPedestrianRed],
  Amarelo: [ImgFaseYellow, ImgPedestrianYellow],
  Verde: [ImgFaseGreen, ImgPedestrianGreen],
  Apagado: [ImgFaseGrey, ImgPedestrianGrey],
};

const arrowIconCache = new Map();

export function clearArrowIconCache() {
  arrowIconCache.clear();
}

export function getIconeFase(cor, ehPedestre) {
  const par = ICONES_FASE[cor] || ICONES_FASE.Apagado;
  return ehPedestre ? par[1] : par[0];
}

export function parseSetasValue(value, posicaoIdx = 0) {
  let parsed = [];
  try {
    if (value) parsed = typeof value === 'string' ? JSON.parse(value) : value;
  } catch (_) {
    parsed = [];
  }
  if (!Array.isArray(parsed)) return [];

  if (parsed.length > 0 && Array.isArray(parsed[0])) {
    parsed = parsed[posicaoIdx] || [];
  }

  return parsed.filter(s => s && s.angulo !== undefined && s.angulo !== null);
}

function cartToSvg(ang) {
  return 90 - ang;
}

function transformPoints(points, angDeg, cx, cy) {
  const rad = (angDeg * Math.PI) / 180;
  const cos = Math.cos(rad);
  const sin = Math.sin(rad);
  return points.map(([x, y]) => [cx + x * cos - y * sin, cy + x * sin + y * cos]);
}

function pointsToPath(pts) {
  return `M${pts.map(([x, y]) => `${x.toFixed(1)},${y.toFixed(1)}`).join(' L')} Z`;
}

function buildArrowMarkerSvg(setas, color, bidirecional, strokeColor) {
  const getAng = s => (s.angulo !== '' && s.angulo !== null && s.angulo !== undefined ? Number(s.angulo) : 0);
  const sc = strokeColor || 'white';
  const sa = `stroke="${sc}" stroke-width="3" stroke-linejoin="round" paint-order="stroke"`;
  const cx = 48;
  const cy = 48;

  const arrowFullPts = [
    [-3.5, 22],
    [-3.5, -12],
    [-11, -12],
    [0, -28],
    [11, -12],
    [3.5, -12],
    [3.5, 22],
  ];
  const tailPts = [
    [-3.5, 30],
    [-3.5, 0],
    [3.5, 0],
    [3.5, 30],
  ];
  const headPts = [
    [-3.5, 0],
    [-3.5, -12],
    [-11, -12],
    [0, -28],
    [11, -12],
    [3.5, -12],
    [3.5, 0],
  ];

  if (bidirecional) {
    let combinedD = '';
    for (let i = 0; i < setas.length; i += 1) {
      const svgAng = cartToSvg(getAng(setas[i]));
      combinedD += `${i > 0 ? ' ' : ''}${pointsToPath(transformPoints(arrowFullPts, svgAng, cx, cy))}`;
    }
    return `<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96" overflow="visible"><path d="${combinedD}" fill="${color}" ${sa} fill-rule="nonzero"/></svg>`;
  }

  const svgAng0 = cartToSvg(getAng(setas[0]));

  if (setas.length === 1) {
    const d = pointsToPath(transformPoints(arrowFullPts, svgAng0, cx, cy));
    return `<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96" overflow="visible"><path d="${d}" fill="${color}" ${sa}/></svg>`;
  }

  const tailSvgAng = svgAng0 + 180;
  let combinedD = pointsToPath(transformPoints(tailPts, tailSvgAng, cx, cy));

  const destinos = setas.slice(1);
  for (let i = 0; i < destinos.length; i += 1) {
    const destSvgAng = cartToSvg(getAng(destinos[i]));
    combinedD += ` ${pointsToPath(transformPoints(headPts, destSvgAng, cx, cy))}`;
  }

  return `<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96" overflow="visible"><path d="${combinedD}" fill="${color}" ${sa} fill-rule="nonzero"/></svg>`;
}

export function getArrowIconSize(zoom) {
  if (zoom >= 20) return 96;
  if (zoom >= 19) return 80;
  if (zoom >= 18) return 64;
  if (zoom >= 17) return 48;
  if (zoom >= 16) return 36;
  if (zoom >= 15) return 28;
  if (zoom >= 14) return 22;
  if (zoom >= 13) return 16;
  return 12;
}

export function getArrowIcon(setasValue, corFase, zoom, bidirecional) {
  const setas = parseSetasValue(setasValue);
  if (!setas.length) return null;
  const color = COR_FASE_MAP[corFase] || COR_FASE_MAP.Apagado;
  const strokeColor = COR_BORDA_MAP[corFase] || COR_BORDA_MAP.Apagado;
  const sz = getArrowIconSize(zoom || 15);
  const key = `${color}|${strokeColor}|${sz}|${bidirecional ? 'bi' : 'dir'}|${JSON.stringify(setas)}`;
  const cached = arrowIconCache.get(key);
  if (cached) return cached;
  const svg = buildArrowMarkerSvg(setas, color, bidirecional, strokeColor);
  const url = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
  let icon = { url };
  if (typeof window !== 'undefined' && window.google && window.google.maps) {
    icon = {
      url,
      scaledSize: new window.google.maps.Size(sz, sz),
      anchor: new window.google.maps.Point(sz / 2, sz / 2),
    };
  }
  arrowIconCache.set(key, icon);
  return icon;
}

export function getArrowMarkerShape(zoom) {
  const sz = getArrowIconSize(zoom || 15);
  const half = Math.round(sz / 2);
  const radius = Math.max(5, Math.round(sz * 0.22));
  return {
    type: 'circle',
    coords: [half, half, radius],
  };
}

function resolverCorFaseVisual(faseRow, blinkOn) {
  const offline = parseInt(faseRow.status_conexao, 10) > 1;
  if (offline) return 'Apagado';

  const corPiscante = corPiscanteIntervaloAtiva(faseRow);
  if (corPiscante) return blinkOn ? corPiscante : 'Apagado';

  if (faseRow.mod_piscante) {
    const isPed = parseInt(faseRow.tipo, 10) !== 1;
    const cor = isPed ? 'Vermelho' : 'Amarelo';
    return blinkOn ? cor : 'Apagado';
  }

  if (faseRow.fase_cor === 'Amarelo' && faseRow.stale) return 'Apagado';
  return faseRow.fase_cor || 'Apagado';
}

function resolverIconeBasico(faseRow, blinkOn) {
  const ehPed = parseInt(faseRow.tipo, 10) !== 1;
  const offline = parseInt(faseRow.status_conexao, 10) > 1;
  let icon = ehPed ? ImgPedestrianGrey : ImgFaseGrey;

  if (offline) return icon;

  const corPiscante = corPiscanteIntervaloAtiva(faseRow);
  if (corPiscante) {
    return getIconeFase(blinkOn ? corPiscante : 'Apagado', ehPed);
  }

  if (faseRow.mod_piscante) {
    return ehPed ? GifPedestrianRedBlink : GifTrafficYellowBlink;
  }

  if (faseRow.fase_cor === 'Vermelho') icon = ehPed ? ImgPedestrianRed : ImgFaseRed;
  else if (faseRow.fase_cor === 'Amarelo' && !faseRow.stale) icon = ehPed ? ImgPedestrianYellow : ImgFaseYellow;
  else if (faseRow.fase_cor === 'Verde') icon = ehPed ? ImgPedestrianGreen : ImgFaseGreen;

  return icon;
}

function pushPin(out, faseRow, contKey, position, icon, shape, mapZoom) {
  out.push({
    key: contKey,
    position,
    icon,
    shape,
    data: faseRow,
    controlador_id: faseRow.controlador_id,
    fase_id: faseRow.fase_id,
    mapZoom,
  });
}

function pinsParaFaseRow(faseRow, { mapZoom, blinkOn }) {
  const pins = [];
  let objQuantidadeLatLon = [];
  if (faseRow.quantidade_lat_lon) {
    try {
      objQuantidadeLatLon =
        typeof faseRow.quantidade_lat_lon === 'string'
          ? JSON.parse(faseRow.quantidade_lat_lon)
          : faseRow.quantidade_lat_lon;
    } catch (_) {
      objQuantidadeLatLon = [];
    }
  }

  const iconBase = resolverIconeBasico(faseRow, blinkOn);
  const { controlador_id: controladorId, fase_id: faseId } = faseRow;

  const tentarSetas = (setasValue, posIdx, contKey, position) => {
    const setas = parseSetasValue(setasValue, posIdx);
    let icon = iconBase;
    let shape;
    if (setas.length > 0) {
      const corFase = resolverCorFaseVisual(faseRow, blinkOn);
      const isPed = parseInt(faseRow.tipo, 10) !== 1;
      const arrowIcon = getArrowIcon(setas, corFase, mapZoom, isPed);
      if (arrowIcon) {
        icon = arrowIcon;
        shape = getArrowMarkerShape(mapZoom);
      }
    }
    pushPin(pins, faseRow, contKey, position, icon, shape, mapZoom);
  };

  if (
    faseRow.fase_latitude === null ||
    faseRow.fase_latitude === undefined ||
    Number.isNaN(parseFloat(faseRow.fase_latitude))
  ) {
    return pins;
  }

  const posDefault = {
    lat: parseFloat(faseRow.fase_latitude),
    lng: parseFloat(faseRow.fase_longitude),
  };

  if (Array.isArray(objQuantidadeLatLon) && objQuantidadeLatLon.length) {
    objQuantidadeLatLon.forEach((pos, idx) => {
      const position = {
        lat: parseFloat(pos.latitude),
        lng: parseFloat(pos.longitude),
      };
      tentarSetas(faseRow.setas, parseInt(idx, 10), `${controladorId}_${faseId}_${idx}`, position);
    });
  } else {
    tentarSetas(faseRow.setas, 0, `${controladorId}_${faseId}`, posDefault);
  }

  return pins;
}

/** Mesma lógica de pins do Mapa de Fases (modo fases, sem pluvio). */
export function coletarPinsFase(list, { mapZoom = 15, blinkOn = true } = {}) {
  let fases = Array.isArray(list) ? list : [];
  if (fases.length > 1) {
    fases = [...fases].sort((a, b) => {
      const na = parseInt(a.numero_controlador, 10) || 0;
      const nb = parseInt(b.numero_controlador, 10) || 0;
      if (na !== nb) return na - nb;
      return (parseInt(a.fase_id, 10) || 0) - (parseInt(b.fase_id, 10) || 0);
    });
  }

  const out = [];
  fases.forEach(row => {
    pinsParaFaseRow(row, { mapZoom, blinkOn }).forEach(p => out.push(p));
  });
  return out;
}
